import MergeProvidersForm from '../../MergeProvidersForm'

import useMergeProvidersHandler from '../../../effects/merge-providers'
import { Provider } from 'graphql'
import { heapEvent } from '@equipmentshare/heaper'

export type MergeProvidersModalProps = {
  onCancel: () => void,
	onSuccess: () => void,
  provider: Provider,
}

export default function MergeProvidersModal( { onCancel, onSuccess, provider }: MergeProvidersModalProps ): JSX.Element {
	const mergeProviders = useMergeProvidersHandler()

	const handleSubmit = async( goodId: number, dupeId: number ) => {
		heapEvent( 'Inventory - Merge Manufacturers Modal - Click - Submit', {} )
		return await mergeProviders( goodId, dupeId )
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Merge Manufacturers Modal - Click - Cancel', {} )
		onCancel()
	}

	return (
		<MergeProvidersForm
			onCancel={handleCancel}
			onSubmit={handleSubmit}
			onSuccess={onSuccess}
			selectedProvider={provider}
		/>
	)
}
